var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateTreatments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 147,
    viewBox: "0 0 178 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.15918,
    y: 2.96973,
    width: 173.645,
    height: 141.731,
    rx: 5,
    fill: "white",
    stroke: "#D5D5D5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32959 7.74365C2.32959 5.53451 4.12045 3.74365 6.32959 3.74365H171.67C173.88 3.74365 175.67 5.53451 175.67 7.74365V33.1025H2.32959V7.74365Z",
    fill: "#D5D5D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9521,
    y: 14.3945,
    width: 70.0953,
    height: 8.05763,
    rx: 4,
    fill: "#FAFAFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6118,
    y: 42.894,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 42.894,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136.388,
    y: 42.894,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7236,
    y: 76.4771,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6118,
    y: 76.4771,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 76.4771,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 136.388,
    y: 76.4771,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7236,
    y: 108.527,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6118,
    y: 108.527,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 108.527,
    width: 21.8882,
    height: 21.8882,
    rx: 2.5,
    stroke: "#F1F1F1",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateTreatments);
export default __webpack_public_path__ + "static/media/EmptyState-Treatments.4ff3bcfc.svg";
export { ForwardRef as ReactComponent };